import { SignupErrorType } from 'features/signUp/types';

export class SignupError extends Error {
  public readonly type: SignupErrorType;

  constructor(message: string, type: SignupErrorType) {
    super(message);
    this.name = 'SignupError';
    this.type = type;

    Object.setPrototypeOf(this, SignupError.prototype);
  }
}
